import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SchoolCoursesService } from '@digilize/language-school/data';
import { MapType } from '@digilize/language-school/definitions';
import { AuthApiService } from '@digilize/shared/data/services/src';
import { AppConfig } from '@digilize/shared/definitions/src';
import { AuthService } from '@digilize/shared/feature/modules/auth/src';
import { APP_CONFIG } from '@digilize/shared/utils/tokens/src';
import { MapService } from '@lsc/services/map.service';
import { tap } from 'rxjs';

@Component({
  selector: 'lsc-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NavbarComponent implements OnInit {
  profileOpened = false;
  me$ = this.authApiService.me.pipe(
    tap((me) => {
      if (!me) {
        this.authApiService.getMe();
      }
    })
  );
  MapType = MapType;
  currentMap$ = this.mapService.currentMap$;
  courses$ = this.schoolCoursesService.courses$;

  constructor(
    private authService: AuthService,
    private authApiService: AuthApiService,
    private router: Router,
    private mapService: MapService,
    public schoolCoursesService: SchoolCoursesService,
    @Inject(APP_CONFIG) public appConfig: AppConfig
  ) {}

  ngOnInit(): void {}
  handlePrivateLessonClick() {
    window.open('https://www.studytrail.nl/group-classes', '_blank');
  }

  handleLogout() {
    this.authService.logout('/auth');
  }

  navigateTo(url: string) {
    const courseId = this.schoolCoursesService.currentCourseId;
    this.router.navigate(['course', courseId, url]);
  }
}
